import React from "react";
import "../assets/css/policy.css";
import Navigation from "../components/Navigation";

function PrivacyPolicy() {
  return (
    <div className="whole whole--with-navbar legal-page">
      <Navigation minimal />

      <div className="legal-page__content">
        <article className="legal-page__panel">
          <h1 className="legal-page__title">
            <span className="highlight">Privacy</span> Policy
          </h1>

          <p className="legal-page__intro">
            This privacy policy outlines how ReImagine
            <span className="legal-page__brand-italic">2.0</span>, a digital
            platform by Traxccel LLC, handles your information collected through
            interactions with our website. By accessing or using the ReImagine
            <span className="legal-page__brand-italic">2.0</span> portal, you
            agree to the terms set forth in this privacy policy.
          </p>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">
              Information Collection and Use
            </h2>
            <p>
              When you interact with ReImagine{" "}
              <span className="legal-page__brand-italic">2.0</span>, we may
              collect log data from your browser, including your IP address,
              browser version, pages visited, time and date of access, and time
              spent on pages.
            </p>
            <p>
              We may also collect personally identifiable information such as
              your name, email address, company name, job title, or other
              relevant contact details to deliver services, provide insights, or
              respond to inquiries.
            </p>
            <p>You may opt out of receiving communications from us at any time.</p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Information Retention</h2>
            <p>
              We retain your data as long as necessary for the purposes described
              in this policy, including legal, regulatory, or contractual
              obligations, or as required to support ongoing engagements.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Cookies</h2>
            <p>
              Our platform uses cookies to enhance user experience. You may
              accept or reject cookies; however, disabling cookies may limit
              certain functionalities of the site.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Information Sharing</h2>
            <p>
              We may share information with trusted third-party providers
              supporting our service delivery. These parties are bound by
              confidentiality and data protection obligations.
            </p>
            <p>
              We may also disclose information if required by law, regulation, or
              in connection with legal proceedings.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Security</h2>
            <p>
              We implement industry-standard technical and organizational
              measures to protect your data. However, no system is completely
              secure, and we cannot guarantee absolute security of your
              information.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Third-Party Links</h2>
            <p>
              ReImagine
              <span className="legal-page__brand-italic">2.0</span> may contain
              links to external websites. We do not control or endorse the
              privacy practices of these third parties and encourage users to
              review their respective policies.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Children&apos;s Privacy</h2>
            <p>
              ReImagine
              <span className="legal-page__brand-italic">2.0</span> is not
              intended for individuals under the age of 13. We do not knowingly
              collect personal data from children. If you believe a child has
              submitted personal information, please contact us immediately.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">
              Changes to This Privacy Policy
            </h2>
            <p>
              This policy may be updated from time to time. Updates will be
              posted here and are effective immediately upon posting.
            </p>
          </section>

          <section className="legal-page__section">
            <h2 className="legal-page__section-title">Contact Us</h2>
            <p>
              For questions or concerns regarding this privacy policy, please
              contact us at{" "}
              <a
                href="mailto:reimagine@traxccel.com"
                className="legal-page__email"
              >
                reimagine@traxccel.com
              </a>
              .
            </p>
          </section>
        </article>
      </div>

      <p className="legal-page__copyright">
        &copy; 2025 Traxccel. All rights reserved.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
